import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { IoCloudUpload } from "react-icons/io5";
import "../../components/DashboardModule/PaymentModal.css";
import { RiDeleteBin5Line } from "react-icons/ri";

const PaymentModal = ({ isOpen, onClose, orderId, onFileUpload, onConfirm }) => {
  const [selectedMethod, setSelectedMethod] = useState("utr");
  const [selectedFile, setSelectedFile] = useState(null);
  const [utrNumber, setUtrNumber] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    onFileUpload(orderId, file); 
  };


  const handleConfirm = () => {
    if (selectedMethod === "utr" && utrNumber === "") {
      alert("Please enter a UTR number.");
      return;
    }

    if (selectedMethod === "image" && !selectedFile) {
      alert("Please upload a payment image.");
      return;
    }

    onConfirm(selectedMethod === "utr" ? utrNumber : selectedFile);

    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal-container">
        <button onClick={onClose} className="payment-modal-close">
          <RxCross2 size={24} />
        </button>

        <h2 className="payment-modal-title">Upload Payment Proof</h2>
        <div>
          <p className="payment-modal-subtitle">Select Method</p>
          <label className="payment-modal-option">
            <input
              type="radio"
              name="method"
              value="utr"
              checked={selectedMethod === "utr"}
              onChange={() => setSelectedMethod("utr")}
            />
            <span>UTR Number</span>
          </label>
          <label className="payment-modal-option">
            <input
              type="radio"
              name="method"
              value="image"
              checked={selectedMethod === "image"}
              onChange={() => setSelectedMethod("image")}
            />
            <span>Upload Payment Image</span>
          </label>

          {selectedMethod === "utr" && (
            <div className="payment-utr-section">
              <label htmlFor="utrNumber" className="payment-modal-label">
                Enter UTR Number
              </label>
              <input
                id="utrNumber"
                type="text"
                value={utrNumber}
                onChange={(e) => setUtrNumber(e.target.value)}
                placeholder="Enter UTR Number"
                className="payment-modal-input"
              />
            </div>
          )}

          {selectedMethod === "image" && (
            <div className="payment-image-section">
              <label className="payment-modal-label">Upload Payment Image</label>
              <div className="payment-upload-box">
                <IoCloudUpload size={50} className="upload-icon" />
                <p className="upload-text">Browse Files to Upload</p>
                <p className="upload-format">(Format: JPG, PNG & PDF)</p>
                <input
                  type="file"
                  className="payment-file-input"
                  accept=".jpg,.png,.pdf"
                  onChange={handleFileChange}
                />
              </div>
              {selectedFile && (
                <div className="uploaded-file-container">
                  <p className="uploaded-file-name">{selectedFile.name}</p>
                  <RiDeleteBin5Line
                    size={20}
                    className="delete-icon"
                    onClick={() => setSelectedFile(null)}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        <div className="payment-modal-actions">
          <button
            className="payment-modal-confirm"
            onClick={() => onConfirm(orderId)} 
          >
            CONFIRM
          </button>
          <button onClick={onClose} className="payment-modal-cancel">
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
